// frontend/src/components/common/FuturesInfo.js
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function FuturesInfo({ latestClose }) {
  const [previousClose, setPreviousClose] = useState(null);
  const [previousCloseDate, setPreviousCloseDate] = useState(null);
  const [sessionDate, setSessionDate] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    (async () => {
      try {
        setError(null);

        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/data/nasdaq_ohlc_daily/previous-session-close`,
          {
            params: { limit: 30 },
            signal: controller.signal,
          }
        );

        const close = Number(data?.close);

        if (!Number.isFinite(close) || close <= 0) {
          throw new Error('유효한 직전 거래일 종가를 찾지 못했습니다.');
        }

        setPreviousClose(close);
        setPreviousCloseDate(data.previous_date ?? null);
        setSessionDate(data.session_date ?? null);
      } catch (e) {
        if (e?.code === 'ERR_CANCELED') return;

        console.error(e);
        setError('직전 거래일 종가를 불러오는 중 오류가 발생했습니다.');
      }
    })();

    return () => {
      controller.abort();
    };
  }, []);

  if (error) return <div>{error}</div>;
  if (previousClose == null) return null;

  const curr = Number(latestClose);

  // FuturesChartUser의 latestClose 초기값이 0일 수 있으므로
  // 실제 시세가 들어오기 전에는 표시하지 않는다.
  if (!Number.isFinite(curr) || curr <= 0) return null;

  const diffValue = curr - previousClose;
  const pctValue = (diffValue / previousClose) * 100;
  const isUp = diffValue >= 0;

  const pct = `${pctValue > 0 ? '+' : ''}${pctValue.toFixed(2)}%`;
  const diff = `${diffValue > 0 ? '+' : ''}${diffValue.toFixed(2)}`;

  const pStyle = {
    color: isUp ? 'red' : 'blue',
    paddingLeft: '2rem',
  };

  return (
    <div
      style={pStyle}
      title={
        previousCloseDate
          ? `세션 기준일: ${sessionDate ?? '-'} / 비교 종가일: ${previousCloseDate}`
          : undefined
      }
    >
      <p>
        <strong style={{ color: 'black' }}>현재가: </strong>
        {curr.toFixed(2)}&nbsp;&nbsp;&nbsp;
        {pct}&nbsp;&nbsp;&nbsp;
        {diff}
      </p>
    </div>
  );
}
